/* eslint-disable consistent-return */
import moment from 'moment';
import Vue from 'vue';

export default {
  state: {
    selectedMergeRequest: null,
    mergeRequests: {},
    mergeRequestDiscussions: [],
    branchDiff: null,
    branchDiffFilters: [],
    mergeRequestDiff: { IN_LINE: null, SIDE_BY_SIDE: null },
    mergeRequestDiffFilters: [],
    branchCommits: {},
    mergeRequestPipeline: {},
    codeOwners: {},
    mergeRequestsLinesCounters: {},
    mergeRequestConflicts: {}
  },
  mutations: {
    setMergeRequests(state, payload) {
      state.mergeRequests = { ...payload };
    },
    selectMergeRequest(state, payload) {
      state.selectedMergeRequest = { ...payload };
    },
    addMergeRequest(state, payload) {
      if (state.mergeRequests.items) {
        state.mergeRequests.items.push(payload);
      } else {
        state.mergeRequests.items = [payload];
      }
    },
    setMergeRequestDiscussions(state, payload) {
      state.mergeRequestDiscussions = [...payload];
    },
    setBranchDiff(state, payload) {
      state.branchDiff = payload;
    },
    setBranchDiffFilters(state, payload) {
      const filterObj = [];
      const addedFilters = [];
      if (payload) {
        payload.forEach((item) => {
          if (!item.languageName) {
            item.languageName = 'Другое';
          }
          if (addedFilters.includes(item.languageName)) return;

          addedFilters.push(item.languageName);
          filterObj.push({
            name: item.languageName,
            id: item.languageName,
            color: item.languageColor
          });
        });
      }

      Vue.set(state, 'branchDiffFilters', filterObj);
    },
    setMergeRequestDiff(state, payload) {
      state.mergeRequestDiff[payload.diffType] = payload?.commitBlobModelMap;
    },
    setMergeRequestDiffFilters(state, payload) {
      const filterObj = [];
      const addedFilters = [];
      const currentMergeRequestDiff = payload?.commitBlobModelMap;
      if (currentMergeRequestDiff) {
        Object.keys(currentMergeRequestDiff)?.forEach((key) => {
          let currentFile = currentMergeRequestDiff[key][0];
          if (!currentFile.languageName) {
            currentFile.languageName = 'Другое';
          }
          if (addedFilters.includes(currentFile.languageName)) return;
          addedFilters.push(currentFile.languageName);
          filterObj.push({
            name: currentFile.languageName,
            id: currentFile.languageName,
            color: currentFile.languageColor
          });
        });
      }

      Vue.set(state, 'mergeRequestDiffFilters', filterObj);
    },
    setBranchCommits(state, payload) {
      const commitGroups = {};
      let lastDate;
      payload.commits.forEach((item) => {
        const date = moment(item.createdAt).format('DD.MM.YYYY');
        if (!lastDate) {
          lastDate = date;
          commitGroups[lastDate] = [];
        }

        if (lastDate !== date) {
          lastDate = date;
          commitGroups[lastDate] = [item];
        } else {
          commitGroups[lastDate].push(item);
        }
      });

      state.branchCommits = { hasNext: payload.hasNext, commits: commitGroups };
    },
    addMergeRequestDiscussion(state, payload) {
      state.mergeRequestDiscussions.push({
        discussionId: payload.uuid,
        id: payload.uuid,
        author: payload.author,
        filePath: payload.filePath,
        createdAt: payload.createdAt || moment.now(),
        message: payload.message,
        newLine: payload.newLine,
        oldLine: payload.oldLine,
        lineDiffId: payload.lineId || null,
        replies: [],
        note: { ...payload }
      });
    },
    addMergeRequestReply(state, payload) {
      // eslint-disable-next-line array-callback-return
      state.mergeRequestDiscussions.find((item, key) => {
        if (item.id === payload.discussionUuid) {
          Vue.set(state.mergeRequestDiscussions[key].note, 'resolved', false);
          state.mergeRequestDiscussions[key].replies.push(payload);
          return true;
        }
      });
    },
    resolveDiscussion(state, payload) {
      // eslint-disable-next-line array-callback-return
      state.mergeRequestDiscussions.find((item, key) => {
        if (item.id === payload.id) {
          Vue.set(state.mergeRequestDiscussions[key].note, 'resolved', true);
          return true;
        }
      });
    },
    setCodeOwners(state, payload) {
      state.codeOwners = [...payload];
    },
    setMergeRequestPipeline(state, payload) {
      state.mergeRequestPipeline = { ...payload };
    },
    deleteMergeRequestDiscussionById(state, payload) {
      const deletedIndex = state.mergeRequestDiscussions.findIndex(
        (element) => element.id === payload
      );
      if (deletedIndex !== -1) state.mergeRequestDiscussions.splice(deletedIndex, 1);
    },
    deleteMergeRequestDiscussionReplyById(state, payload) {
      for (let i = 0; i < state.mergeRequestDiscussions.length; i++) {
        const discussion = state.mergeRequestDiscussions[i];
        const deletedIndex = discussion?.replies?.findIndex((element) => element.id === payload);
        if (deletedIndex !== -1) {
          state.mergeRequestDiscussions[i]?.replies.splice(deletedIndex, 1);
          break;
        }
      }
    },
    setMergeRequestsLinesCounters(state, payload) {
      Vue.set(state.mergeRequestsLinesCounters, payload?.mergeRequestId, payload?.linesData);
    },
    setMergeRequestConflicts(state, payload) {
      state.mergeRequestConflicts = payload;
    }
  },
  actions: {
    setMergeRequests(state, payload) {
      state.commit('setMergeRequests', payload);
    },
    selectMergeRequest(state, payload) {
      state.commit('selectMergeRequest', payload);
    },
    addMergeRequest(state, payload) {
      state.commit('addMergeRequest', payload);
    },
    setMergeRequestDiscussions(state, payload) {
      state.commit('setMergeRequestDiscussions', payload);
    },
    setBranchDiff(state, payload) {
      state.commit('setBranchDiff', payload);
      state.commit('setBranchDiffFilters', payload);
    },
    setMergeRequestDiff(state, payload) {
      state.commit('setMergeRequestDiff', payload);
      state.commit('setMergeRequestDiffFilters', payload);
    },
    setBranchCommits(state, payload) {
      state.commit('setBranchCommits', payload);
    },
    addMergeRequestDiscussion(state, payload) {
      state.commit('addMergeRequestDiscussion', payload);
    },
    addMergeRequestReply(state, payload) {
      state.commit('addMergeRequestReply', payload);
    },
    resolveDiscussion(state, payload) {
      state.commit('resolveDiscussion', payload);
    },
    setCodeOwners(state, payload) {
      state.commit('setCodeOwners', payload);
    },
    setMergeRequestPipeline(state, payload) {
      state.commit('setMergeRequestPipeline', payload);
    },
    deleteMergeRequestDiscussionById(state, payload) {
      state.commit('deleteMergeRequestDiscussionById', payload);
    },
    deleteMergeRequestDiscussionReplyById(state, payload) {
      state.commit('deleteMergeRequestDiscussionReplyById', payload);
    },
    setMergeRequestsLinesCounters(state, payload) {
      state.commit('setMergeRequestsLinesCounters', payload);
    },
    setMergeRequestConflicts(state, payload) {
      state.commit('setMergeRequestConflicts', payload);
    }
  },
  getters: {
    getMergeRequests(state) {
      return state.mergeRequests;
    },
    getSelectedMergeRequest(state) {
      return state.selectedMergeRequest;
    },
    getMergeRequestsDiscussions(state) {
      return state.mergeRequestDiscussions;
    },
    getBranchDiff(state) {
      return state.branchDiff;
    },
    getBranchDiffFilters(state) {
      return state.branchDiffFilters;
    },
    getBranchDiffByLanguageName(state) {
      const filterObj = {};
      if (state.branchDiff) {
        state.branchDiff.forEach((item) => {
          if (filterObj[item.languageName]) {
            filterObj[item.languageName].push(item);
            return;
          }

          filterObj[item.languageName] = [item];
        });
      }
      return filterObj;
    },
    getMergeRequestDiff(state) {
      return state.mergeRequestDiff;
    },
    getMergeRequestDiffByType: (state) => (diffType) => state.mergeRequestDiff[diffType] || null,
    getMergeRequestDiffFilters(state) {
      return state.mergeRequestDiffFilters;
    },
    getMergeRequestDiffByLanguageNameAndDiffType: (state) => (diffType) => {
      const filterObj = {};
      const currentMergeRequestDiff = state.mergeRequestDiff[diffType];
      if (currentMergeRequestDiff) {
        Object.keys(currentMergeRequestDiff)?.forEach((key) => {
          let currentFile = currentMergeRequestDiff[key][0];
          if (filterObj[currentFile.languageName]) {
            filterObj[currentFile.languageName][key] = currentMergeRequestDiff[key];
            return;
          }

          filterObj[currentFile.languageName] = { [key]: currentMergeRequestDiff[key] };
        });
      }
      return filterObj;
    },
    getBranchCommits(state) {
      return state.branchCommits;
    },
    getDiscussionByLineId: (state) => (lineId) => {
      if (lineId) {
        return state.mergeRequestDiscussions.find((item) => item.lineDiffId === lineId);
      }
      return undefined;
    },
    getCodeOwners(state) {
      return state.codeOwners;
    },
    getMergeRequestPipeline(state) {
      return state.mergeRequestPipeline;
    },
    getMergeRequestsLinesCounters: (state) => (mergeRequestId) =>
      state.mergeRequestsLinesCounters[mergeRequestId] || null,
    getChangedFilesNumber(state) {
      return Object.keys(state?.branchDiff)?.length;
    },
    getMergeRequestFilesNumberByDiffType: (state) => (diffType) => {
      if (state?.mergeRequestDiff[diffType])
        return Object.keys(state?.mergeRequestDiff[diffType])?.length;
      else return null;
    },
    getMergeRequestConflicts(state) {
      return state.mergeRequestConflicts;
    }
  }
};
